import WhatsAppIcon from '../../components/WhatsAppIcon';
import heroImage from '../../assets/images/hero_image.png';
import socialMediaImage from '../../assets/images/social_media.jpeg';
import trafegoPagoImage from '../../assets/images/trafego_pago_image.jpeg';
import serviceVideo from '../../assets/videos/service_video.mov';

const wa = (topic) =>
  topic
    ? `https://wa.me/5511986304696?text=${encodeURIComponent(
        `Olá! Vim pelo site da l'ora e quero saber mais sobre ${topic}.`
      )}`
    : "https://wa.me/5511986304696?text=Ol%C3%A1!%20Vim%20pelo%20site%20da%20l'ora%20e%20gostaria%20de%20uma%20proposta.";

function WaLink({ topic, children }) {
  return (
    <a className="link" href={wa(topic)} target="_blank" rel="noopener noreferrer">
      <WhatsAppIcon />
      <span>
        {children}
        <span className="arrow" aria-hidden="true">
          →
        </span>
      </span>
    </a>
  );
}

export default function Services() {
  return (
    <section className="section wrap" id="servicos">
      <div className="heading">
        <div>
          <div className="eyebrow">Estratégia &amp; Criação</div>
          <h2>
            O que sua marca<br />
            precisa <em>comunicar?</em>
          </h2>
        </div>
        <p>
          <strong>A l’ora te ajuda a entender.</strong>
          <br />
          Serviços avulsos ou um plano completo. Você escolhe. A l’ora cria.
        </p>
      </div>

      <div className="grid">
        {/* 01 — Videomaker & Storymaker */}
        <article className="card">
          <div className="visual film" aria-hidden="true">
            <video
              className="film-video"
              src={serviceVideo}
              autoPlay
              loop
              muted
              playsInline
              aria-label="Vídeo de serviços l’ora"
            />
            <span className="film-type">em cena.</span>
          </div>
          <div className="card-content">
            <div className="card-top">
              <h3>Videomaker &amp; Storymaker</h3>
              <span className="num">01</span>
            </div>
            <p>
              Roteiro, direção e gravação de vídeos para negócios, além de cobertura de
              eventos e conteúdo em tempo real.
            </p>
            <div className="tags">
              <span>Videomaker</span>
              <span>Storymaker</span>
              <span>Vídeos institucionais</span>
              <span>Cobertura de eventos</span>
              <span>Reels &amp; TikTok</span>
            </div>
            <WaLink topic="Videomaker & Storymaker">Quero gravar</WaLink>
          </div>
        </article>

        {/* 02 — Fotografia */}
        <article className="card">
          <div className="visual photo real-photo">
            <img src={heroImage} alt="Fotografia l’ora" loading="lazy" />
            <div className="photo-badge">
              <span>l’ora</span>
              <span>registro.</span>
            </div>
          </div>
          <div className="card-content">
            <div className="card-top">
              <h3>Fotografia</h3>
              <span className="num">02</span>
            </div>
            <p>Retratos, equipes, produtos e ambientes que mostram o valor da sua marca.</p>
            <div className="tags">
              <span>Casamentos</span>
              <span>Corporativo</span>
              <span>15 Anos</span>
              <span>Gestante</span>
              <span>Eventos</span>
            </div>
            <WaLink topic="Fotografia">Quero fotografar</WaLink>
          </div>
        </article>

        {/* 03 — Social Media & Gestão Estratégica */}
        <article className="card">
          <div className="visual media-visual" aria-hidden="true">
            <img
              src={socialMediaImage}
              alt="Social Media & Gestão Estratégica l’ora"
              loading="lazy"
              className="card-full-img"
            />
          </div>
          <div className="card-content">
            <div className="card-top">
              <h3>Social Media &amp; Gestão Estratégica</h3>
              <span className="num">03</span>
            </div>
            <p>
              Planejamento e gestão estratégica para fortalecer sua presença digital e
              comunicar o valor da sua marca.
            </p>
            <div className="tags">
              <span>Planejamento de conteúdo</span>
              <span>Gestão de redes sociais</span>
              <span>Posicionamento digital</span>
              <span>Calendário editorial</span>
              <span>Estratégia de comunicação</span>
              <span>Acompanhamento</span>
            </div>
            <WaLink topic="Social Media & Gestão Estratégica">Quero cuidar das minhas redes</WaLink>
          </div>
        </article>

        {/* 04 — Criação de Conteúdo & Design Criativo */}
        <article className="card">
          <div className="visual design-card" aria-hidden="true">
            <div className="design-art">
              <div className="art-layer art-layer-1">IDENTIDADE</div>
              <div className="art-layer art-layer-2">DESIGN CRIATIVO</div>
              <div className="art-swatches">
                <span className="swatch s1" />
                <span className="swatch s2" />
                <span className="swatch s3" />
              </div>
            </div>
            <div className="design-title">
              visual<br />com<br />intenção.
            </div>
          </div>
          <div className="card-content">
            <div className="card-top">
              <h3>Criação de Conteúdo &amp; Design Criativo</h3>
              <span className="num">04</span>
            </div>
            <p>
              Conteúdos visuais criados com identidade, criatividade e intenção para comunicar o
              que torna sua marca única.
            </p>
            <div className="tags">
              <span>Artes estáticas</span>
              <span>Carrosséis</span>
              <span>Identidade visual</span>
              <span>Peças para campanhas</span>
              <span>Design para redes sociais</span>
            </div>
            <WaLink topic="Criação de Conteúdo & Design Criativo">Quero design criativo</WaLink>
          </div>
        </article>

        {/* 05 — Tráfego Pago */}
        <article className="card card-wide">
          <div className="visual media-visual" aria-hidden="true">
            <img
              src={trafegoPagoImage}
              alt="Tráfego Pago l’ora"
              loading="lazy"
              className="card-full-img"
            />
          </div>
          <div className="card-content">
            <div className="card-top">
              <h3>Tráfego Pago</h3>
              <span className="num">05</span>
            </div>
            <p>Anúncios com público, criativos e objetivos definidos para gerar resultados.</p>
            <div className="tags">
              <span>Planejamento de campanhas</span>
              <span>Públicos segmentados</span>
              <span>Otimização contínua</span>
              <span>Meta Ads &amp; Google Ads</span>
            </div>
            <WaLink topic="Tráfego Pago">Quero anunciar</WaLink>
          </div>
        </article>
      </div>

      {/* Extras */}
      <div className="extras">
        <article className="extra">
          <svg viewBox="0 0 34 34" aria-hidden="true">
            <path d="M5 8h24v19H5zM12 8v19M21 8v19M5 17h24" />
          </svg>
          <h3>Edição de vídeo</h3>
          <p>Cortes, legendas e ritmo para seu material ganhar forma e prender atenção.</p>
          <WaLink topic="Edição de vídeo">Quero saber mais</WaLink>
        </article>

        <article className="extra">
          <svg viewBox="0 0 34 34" aria-hidden="true">
            <path d="M8 4h18v27H8zM12 11h10M12 17h10M12 23h6" />
          </svg>
          <h3>Roteiro &amp; Estratégia</h3>
          <p>A ideia certa, com uma mensagem clara e uma estratégia bem definida.</p>
          <WaLink topic="Roteiro & Estratégia">Quero saber mais</WaLink>
        </article>

        <article className="extra">
          <svg viewBox="0 0 34 34" aria-hidden="true">
            <path d="M4 5h26v25H4zM4 21l9-9 7 7 4-4 6 6" />
          </svg>
          <h3>Design Criativo</h3>
          <p>Identidade visual e direção estética consistente para todas as suas peças.</p>
          <WaLink topic="Design Criativo">Quero saber mais</WaLink>
        </article>
      </div>
    </section>
  );
}
